"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageHero2 = ImageHero2;
exports["default"] = void 0;
var _debounce = _interopRequireDefault(require("@sd-utility/debounce"));
var _ChevronRight = _interopRequireDefault(require("@tvg/fuse-icons/lib/ChevronRight"));
var _fuseUtils = require("@tvg/fuse-utils");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _buttons = require("../../fuse-buttons/src/buttons");
var _imageHero2Config = require("./image-hero-2-config");
var _styledImageHero = require("./styled-image-hero-2");
var _excluded = ["background", "image", "text", "link", "secondaryLink", "dataAnalyticsId", "dataTestId", "dataAnalyticsIdSecondary", "variant"];
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _objectDestructuringEmpty(t) {
  if (null == t) throw new TypeError("Cannot destructure " + t);
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var useCallback = _react["default"].useCallback,
  useEffect = _react["default"].useEffect,
  useLayoutEffect = _react["default"].useLayoutEffect,
  useRef = _react["default"].useRef;
var typographyConfig = _imageHero2Config.componentConfig.typography;
var defaultProps = {
  background: 'white',
  dataTestId: 'fuse-image-hero-2-test-id',
  dataAnalyticsId: undefined,
  dataAnalyticsIdSecondary: undefined,
  image: {
    fetchPriority: undefined,
    isLazy: true,
    position: 'right',
    ratio: '1:1'
  },
  link: {
    href: undefined,
    onClick: undefined,
    text: undefined
  },
  secondaryLink: {
    href: undefined,
    onClick: undefined,
    text: undefined
  },
  text: {
    description: undefined,
    heading: undefined,
    headline: undefined,
    headlineSizeV3: 'small',
    headlineTag: 'h2',
    representative: undefined,
    representativeColour: 'brand',
    subheadline: undefined,
    subheadlineTag: 'h3',
    terms: undefined
  },
  variant: _imageHero2Config.variants.v2
};
var propTypes = {
  background: _propTypes["default"].oneOf(_imageHero2Config.backgrounds),
  dataAnalyticsId: _propTypes["default"].string,
  dataTestId: _propTypes["default"].string,
  dataAnalyticsIdSecondary: _propTypes["default"].string,
  image: _propTypes["default"].shape({
    alt: _propTypes["default"].string.isRequired,
    fetchPriority: _propTypes["default"].oneOf(['auto', 'high', 'low']),
    isLazy: _propTypes["default"].bool,
    fallbackSource: _propTypes["default"].string.isRequired,
    position: _propTypes["default"].oneOf(['left', 'right']),
    ratio: _propTypes["default"].oneOf(['1:1', '4:3']),
    sources: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      srcSet: _propTypes["default"].string.isRequired,
      type: _propTypes["default"].string.isRequired
    }))
  }),
  link: _propTypes["default"].shape({
    href: _propTypes["default"].string,
    onClick: _propTypes["default"].func,
    text: _propTypes["default"].string
  }),
  secondaryLink: _propTypes["default"].shape({
    href: _propTypes["default"].string,
    onClick: _propTypes["default"].func,
    text: _propTypes["default"].string
  }),
  text: _propTypes["default"].shape({
    description: _propTypes["default"].string,
    headline: _propTypes["default"].string,
    headlineSizeV3: _propTypes["default"].oneOf(Object.keys(_imageHero2Config.headlineSizesV3)),
    // xsmall, small, medium, large
    headlineTag: _propTypes["default"].string,
    representative: _propTypes["default"].string,
    representativeColour: _propTypes["default"].oneOf(['brand', 'grey']),
    subheadline: _propTypes["default"].string,
    subheadlineTag: _propTypes["default"].string,
    terms: _propTypes["default"].string
  }),
  variant: _propTypes["default"].oneOf([_imageHero2Config.variants.v2, _imageHero2Config.variants.v3])
};

/**
 * For v2, Function returns mobileHeadlineSize, tabletHeadlineSize and desktopHeadlineSize based on the character count passed
 * For v3, Function returns mobileHeadlineSize, tabletHeadlineSize and desktopHeadlineSize based on the headlineSizeV3 prop passed i.e. xsmall, small, medium, large
 * @param {number} headlineCharacterCount - Total number of characters of the Image Hero Heading
 * @returns {array} [mobileHeadlineSize, tabletHeadlineSize, desktopHeadlineSize]
 */

var getHeadlineSize = function getHeadlineSize(headlineCharacterCount, _ref) {
  var isV3 = _ref.isV3,
    hasRepresentative = _ref.hasRepresentative,
    headlineSizeV3 = _ref.headlineSizeV3;
  // Sets headline size for V3
  if (isV3) {
    // Get representative text sizes from config
    var aprHeadlineSizes = [typographyConfig.size.representative.xxs[_imageHero2Config.variants.v3], typographyConfig.size.representative.m[_imageHero2Config.variants.v3], typographyConfig.size.representative.l[_imageHero2Config.variants.v3]];

    // Set headline size based on representative text size from config when rep text is set
    var mobileHeadlineSize = _imageHero2Config.headlineSizesV3[headlineSizeV3].xxs;
    var tabletHeadlineSize = _imageHero2Config.headlineSizesV3[headlineSizeV3].m;
    var desktopHeadlineSize = _imageHero2Config.headlineSizesV3[headlineSizeV3].l;
    return hasRepresentative ? aprHeadlineSizes : [mobileHeadlineSize, tabletHeadlineSize, desktopHeadlineSize];
  }

  // Sets headline size for V2
  if (headlineCharacterCount < 16) return [2, 6, 11];
  if (headlineCharacterCount > 15 && headlineCharacterCount < 30) return [2, 5, 9];
  if (headlineCharacterCount > 29 && headlineCharacterCount < 45) return [2, 4, 8];
  return [2, 4, 8];
};
function ImageHero2(_ref2) {
  var background = _ref2.background,
    image = _ref2.image,
    text = _ref2.text,
    link = _ref2.link,
    secondaryLink = _ref2.secondaryLink,
    dataAnalyticsId = _ref2.dataAnalyticsId,
    dataTestId = _ref2.dataTestId,
    dataAnalyticsIdSecondary = _ref2.dataAnalyticsIdSecondary,
    variant = _ref2.variant,
    props = _objectWithoutProperties(_ref2, _excluded);
  var sanitisedBackground = _imageHero2Config.backgrounds.includes(background) ? background : 'white';
  var sanitisedImagePosition = ['left', 'right'].includes(image === null || image === void 0 ? void 0 : image.position) ? image.position : 'right';
  var sanitisedImageRatio = ['1:1', '4:3'].includes(image === null || image === void 0 ? void 0 : image.ratio) ? image.ratio : '1:1';
  var sanitisedHeadlineSizeV3 = Object.keys(_imageHero2Config.headlineSizesV3).includes(text === null || text === void 0 ? void 0 : text.headlineSizeV3) ? text === null || text === void 0 ? void 0 : text.headlineSizeV3 : 'small';
  var sanitisedVariant = [_imageHero2Config.variants.v2, _imageHero2Config.variants.v3].includes(variant) ? variant : _imageHero2Config.variants.v2;
  var isV3 = sanitisedVariant === _imageHero2Config.variants.v3;
  var wrapSymbolHeadline = (0, _fuseUtils.transformer)(text.headline);
  var wrapSymbolSubHeadline = (0, _fuseUtils.transformer)(text.subheadline);
  var wrapSymbolDescription = (0, _fuseUtils.transformer)(text.description);
  var headlineCharacterCount = text.headline ? text.headline.length : 0;
  var _getHeadlineSize = getHeadlineSize(headlineCharacterCount, {
      isV3: isV3,
      hasRepresentative: !!text.representative,
      headlineSizeV3: sanitisedHeadlineSizeV3
    }),
    _getHeadlineSize2 = _slicedToArray(_getHeadlineSize, 3),
    mobileHeadlineSize = _getHeadlineSize2[0],
    tabletHeadlineSize = _getHeadlineSize2[1],
    desktopHeadlineSize = _getHeadlineSize2[2];
  var pictureProps = _extends({}, (_objectDestructuringEmpty(image), image));
  var activePrimaryCTA = link.text && (link.href || link.onClick);
  var activeSecondaryCTA = secondaryLink.text && (secondaryLink.href || secondaryLink.onClick);
  // Remove content wrapper padding based on the condition below
  var noMobileContentPadding = variant === _imageHero2Config.variants.v3 && !text.subheadline && !text.description && !text.representative && !text.terms && !activePrimaryCTA && !activeSecondaryCTA || variant === _imageHero2Config.variants.v2 && !text.headline && !text.subheadline && !text.description && !text.representative && !text.terms && !activePrimaryCTA && !activeSecondaryCTA;
  // Configs
  // Text Config
  var textSize = typographyConfig.size,
    textType = typographyConfig.type;
  // Refs
  var copyWrapperRef = useRef();
  var buttonsContainerRef = useRef();
  var primaryButtonRef = useRef();
  var secondaryButtonRef = useRef();
  /**
   * Function that sets the layout of the buttons to side by side or stacked depending on the buttons width, gap, container size and viewport
   */
  var setButtonsLayout = useCallback(function () {
    // Button gap set to initial side by side gap of --spacing-global-space6 = 16px
    var buttonGap = 16;
    var copyWrapperWidth = Math.floor(copyWrapperRef.current.offsetWidth) - 8; // Round down and adding some margins to account for button borders + extra spacing when total button widths calculation is close to copy wrapper width
    var primaryButtonClone = primaryButtonRef.current.cloneNode(true);
    var secondaryButtonClone = secondaryButtonRef.current.cloneNode(true);

    /**
     * Calculate actual widths of buttons by setting width to auto from 100% of container when stacked
     * Using cloned buttons for calculation removes chance of 'jank' as its not visible when appended and removed from DOM due to style set
     */
    Object.assign(primaryButtonClone.style, {
      width: 'auto',
      position: 'absolute',
      visibility: 'hidden'
    });
    Object.assign(secondaryButtonClone.style, {
      width: 'auto',
      position: 'absolute',
      visibility: 'hidden'
    });
    buttonsContainerRef.current.appendChild(primaryButtonClone);
    buttonsContainerRef.current.appendChild(secondaryButtonClone);

    // Get primary and secondary button widths
    var primaryButtonWidth = primaryButtonClone.offsetWidth;
    var secondaryButtonWidth = secondaryButtonClone.offsetWidth;
    var totalButtonsWidth = Math.ceil(primaryButtonWidth + buttonGap + secondaryButtonWidth); // Round up value so to mitigate edge cases

    buttonsContainerRef === null || buttonsContainerRef === void 0 || buttonsContainerRef.current.removeChild(primaryButtonClone);
    buttonsContainerRef === null || buttonsContainerRef === void 0 || buttonsContainerRef.current.removeChild(secondaryButtonClone);

    // Update button styles to stacked or side by side based on total button widths
    if (totalButtonsWidth >= copyWrapperWidth && !buttonsContainerRef.current.classList.contains('fuse-image-hero-2__buttons--stacked')) {
      buttonsContainerRef.current.classList.add('fuse-image-hero-2__buttons--stacked');
      primaryButtonRef.current.classList.add('fuse-image-hero-2__primary-button--stacked');
      secondaryButtonRef.current.classList.add('fuse-image-hero-2__secondary-button--stacked');
    }
    if (totalButtonsWidth < copyWrapperWidth && buttonsContainerRef.current.classList.contains('fuse-image-hero-2__buttons--stacked')) {
      buttonsContainerRef.current.classList.remove('fuse-image-hero-2__buttons--stacked');
      primaryButtonRef.current.classList.remove('fuse-image-hero-2__primary-button--stacked');
      secondaryButtonRef.current.classList.remove('fuse-image-hero-2__secondary-button--stacked');
    }
  }, [link.text, secondaryLink.text]);

  /**
   * Add resize event listener (set buttons layout) to window for when user changes orientation or viewport size
   */
  useEffect(function () {
    if (activePrimaryCTA && activeSecondaryCTA) {
      var handleResize = (0, _debounce["default"])(function () {
        setButtonsLayout();
      }, 200);
      window.addEventListener('resize', handleResize);
      return function () {
        window.removeEventListener('resize', handleResize);
      };
    }
    return function () {};
  }, []);

  /**
   * Using useLayoutEffect to remove 'jank' of button growing to the available space when stacked ie execute effects first before rendering
   */
  useLayoutEffect(function () {
    if (activePrimaryCTA && activeSecondaryCTA) setButtonsLayout();
  }, [link.text, secondaryLink.text]);
  return /*#__PURE__*/_react["default"].createElement(_styledImageHero.StyledImageHero, _extends({
    as: activePrimaryCTA && !activeSecondaryCTA && 'a',
    background: sanitisedBackground,
    href: link.href,
    "data-analyticsid": activePrimaryCTA && !activeSecondaryCTA && dataAnalyticsId,
    "data-testid": dataTestId,
    onClick: !link.href && !activeSecondaryCTA ? link.onClick : undefined
  }, props), /*#__PURE__*/_react["default"].createElement(_styledImageHero.StyledImageHeroContainer, {
    imagePosition: sanitisedImagePosition
  }, /*#__PURE__*/_react["default"].createElement(_styledImageHero.StyledImageWrapper, {
    variant: sanitisedVariant,
    imageRatio: sanitisedImageRatio
  }, text.headline && isV3 && /*#__PURE__*/_react["default"].createElement(_styledImageHero.StyledImageHeading, {
    size: {
      xxs: "".concat(mobileHeadlineSize),
      m: "".concat(tabletHeadlineSize),
      l: "".concat(desktopHeadlineSize)
    },
    tag: text.headlineTag,
    type: textType.headline,
    variant: sanitisedVariant,
    dangerouslySetInnerHTML: {
      __html: wrapSymbolHeadline
    }
  }), /*#__PURE__*/_react["default"].createElement(_styledImageHero.StyledPicture, _extends({
    className: "fuse-image-hero-2__picture"
  }, pictureProps, {
    variant: sanitisedVariant,
    imageRatio: sanitisedImageRatio
  }))), /*#__PURE__*/_react["default"].createElement(_styledImageHero.StyledContentWrapper, {
    imagePosition: sanitisedImagePosition,
    noMobileContentPadding: noMobileContentPadding,
    variant: sanitisedVariant
  }, /*#__PURE__*/_react["default"].createElement(_styledImageHero.StyledCopyWrapper, {
    ref: copyWrapperRef
  }, text.headline && /*#__PURE__*/_react["default"].createElement(_styledImageHero.StyledHeading, {
    size: {
      xxs: "".concat(mobileHeadlineSize),
      m: "".concat(tabletHeadlineSize),
      l: "".concat(desktopHeadlineSize)
    },
    tag: text.headlineTag,
    type: textType.headline,
    variant: sanitisedVariant,
    dangerouslySetInnerHTML: {
      __html: wrapSymbolHeadline
    }
  }), text.subheadline && /*#__PURE__*/_react["default"].createElement(_styledImageHero.StyledSubheading, {
    size: {
      xxs: textSize.subHeadline.xxs[sanitisedVariant],
      m: textSize.subHeadline.m[sanitisedVariant],
      l: textSize.subHeadline.l[sanitisedVariant]
    },
    tag: text.subheadlineTag,
    type: textType.subHeadline,
    dangerouslySetInnerHTML: {
      __html: wrapSymbolSubHeadline
    }
  }), text.description && /*#__PURE__*/_react["default"].createElement(_styledImageHero.StyledDescription, {
    size: {
      xxs: textSize.description.xxs[sanitisedVariant],
      l: textSize.description.l[sanitisedVariant]
    },
    tag: "p",
    type: textType.description,
    dangerouslySetInnerHTML: {
      __html: wrapSymbolDescription
    }
  }), text.representative && /*#__PURE__*/_react["default"].createElement(_styledImageHero.StyledRepresentative, {
    background: sanitisedBackground,
    size: {
      xxs: textSize.representative.xxs[sanitisedVariant],
      l: textSize.representative.l[sanitisedVariant]
    },
    tag: "p",
    type: textType.representative,
    representativeColour: text.representativeColour
  }, (0, _fuseUtils.transformer)(text.representative)), text.terms && /*#__PURE__*/_react["default"].createElement(_styledImageHero.StyledTerms, {
    size: {
      xxs: textSize.terms.xxs[sanitisedVariant]
    },
    tag: "p",
    type: textType.terms,
    dangerouslySetInnerHTML: {
      __html: text.terms
    }
  })), activePrimaryCTA && /*#__PURE__*/_react["default"].createElement(_styledImageHero.StyledButtons, {
    ref: buttonsContainerRef
  }, activeSecondaryCTA ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_buttons.Button, _extends({}, link, {
    className: "fuse-image-hero-2__primary-button",
    "data-analyticsid": dataAnalyticsId,
    "data-testid": "fuse-image-hero-2-primary-button-test-id",
    href: link.href,
    icon: /*#__PURE__*/_react["default"].createElement(_ChevronRight["default"], null),
    iconRight: true,
    onClick: link.onClick,
    ref: primaryButtonRef,
    size: {
      xxs: 'small',
      m: 'medium',
      l: 'large'
    },
    variant: "secondary"
  }), link.text), /*#__PURE__*/_react["default"].createElement(_buttons.Button, _extends({}, secondaryLink, {
    className: "fuse-image-hero-2__secondary-button",
    "data-analyticsid": dataAnalyticsIdSecondary,
    "data-testid": "fuse-image-hero-2-secondary-button-test-id",
    href: secondaryLink.href,
    onClick: secondaryLink.onClick,
    ref: secondaryButtonRef,
    size: {
      xxs: 'small',
      m: 'medium',
      l: 'large'
    },
    variant: "tertiary"
  }), secondaryLink.text)) : /*#__PURE__*/_react["default"].createElement(_buttons.SpanButton, _extends({}, link, {
    className: "fuse-image-hero-2__span-button",
    "data-testid": "fuse-image-hero-2-span-button-test-id",
    icon: /*#__PURE__*/_react["default"].createElement(_ChevronRight["default"], null),
    iconRight: true,
    size: {
      xxs: 'small',
      m: 'medium',
      l: 'large'
    },
    variant: "secondary"
  }), link.text)))));
}
ImageHero2.propTypes = propTypes;
ImageHero2.defaultProps = defaultProps;
var _default = exports["default"] = ImageHero2;